import { useContext, useState } from "react";
import styles from "../bvn-verification/bvn-verification.module.scss";
import Stepper from "../components/stepper";
import { STEPS } from "../constants";
import OtpInput from "../../../components/Input/OtpInput";
import {
  decodeBase64,
  encodeBase64,
  getQuery,
  maskEmail,
} from "../../../utils/generalUtils";
import { useHistory } from "react-router";
import { verifyBvnSendOtp, verifyBvnVerifyOtp } from "../../../swr/mortgage";
import LoadingContext from "../../../contexts/LoadingContext";
import { VerifyBvnVerifyOtpRequest } from "../../../types/mortgage";
import ToastContext from "../../../contexts/ToastContext";

const BvnOtpVerification = () => {
  const [otp, setOtp] = useState("");
  const history = useHistory();
  const bvn = getQuery("app");
  const encodedEmail = getQuery("tac");
  const canSubmit = otp?.length === 6;

  const { setLoading } = useContext(LoadingContext);
  const { openError } = useContext(ToastContext);

  const handleResend = async (bvn: string | null) => {
    if (!bvn) {
      openError("An error occurred. Please try again");
      history.goBack();
      return;
    }
    setLoading(true);
    bvn = decodeBase64(bvn);
    try {
      const { data, error } = await verifyBvnSendOtp({
        bvn,
        consentGiven: true,
      });
      if (data) {
        history.push(`/bvn-otp-verification`);
      }
      if (error) {
        openError(
          error?.response?.data?.Message ||
            error?.response?.data?.message ||
            "An error occurred"
        );
      }
    } catch (error) {
      openError("An error occurred");
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async (req: VerifyBvnVerifyOtpRequest) => {
    if (!bvn) {
      openError("An error occurred. Please try again");
      history.goBack();
      return;
    }
    setLoading(true);
    req.bvn = decodeBase64(bvn);
    try {
      const { data, error } = await verifyBvnVerifyOtp(req);
      if (data?.data) {
        const encodedMortgageApplicationId = encodeBase64(
          String(data.data.mortgageApplicationId)
        );
        history.push(
          `/mortgage-active-loans?app=${bvn}&dippa=${encodedMortgageApplicationId}`
        );
      }
      if (error) {
        openError(
          error?.response?.data?.Message ||
            error?.response?.data?.message ||
            "An error occurred"
        );
      }
    } catch (error) {
      openError("An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <span className={styles.header_text}>Apply For Mortgage</span>
      </header>

      <Stepper steps={STEPS} currentStep={0} />

      <span style={{ marginBottom: "3em" }} className={styles.h4_38}>
        {encodedEmail
          ? `Kindly input the 6 digit OTP code we sent to your email: ${decodeBase64(
              encodedEmail
            )}`
          : "Email linked to BVN not found"}
      </span>

      <OtpInput
        value={otp}
        onChange={setOtp}
        onResend={() => handleResend(bvn)}
      />

      <div className={styles.flex_bet}>
        <span
          role="button"
          className={styles.back}
          onClick={() => history.goBack()}
        >
          Back
        </span>
        <button
          style={{
            backgroundColor: canSubmit
              ? "rgba(13, 96, 13, 1)"
              : "rgba(13, 96, 13, 0.5)",
          }}
          className={styles.button}
          disabled={!canSubmit}
          type="button"
          onClick={() => verifyOtp({ bvn, otp })}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default BvnOtpVerification;
